{
  "ui": {
    "feedback": "Opinie",
    "credits": "Twórcy",
    "currentMaintainer": "Obecny opiekun",
    "maintainerPeriod": "Od 2026 roku",
    "originalTeam": "Oryginalny zespół",
    "creditsCampaigns": "Dżungla i Boże Narodzenie",
    "moreSettings": "Więcej ustawień",
    "chooseLanguage": "Wybierz język",
    "notebookTools": "Narzędzia zeszytu",
    "visualGuide": "Przewodnik obrazkowy",
    "templeSoon": "Już wkrótce",
    "playAdventure": "Graj",
    "story": "Historia",
    "loadingAdventure": "Pakujemy się na przygodę…",
    "storyOpening": "Szkolna wycieczka do dżungli. Marco i Sophia odkrywają ją z przyjaciółmi. Kolorowy ptak przyciąga uwagę Marca, który podąża za nim między drzewa. Nagle zostaje sam. Pomóż odkrywcom znaleźć drogę!",
    "storyEnding": "Marco i Sophia razem docierają do zaginionej świątyni. Tajemnicza twarz strzeże wejścia. Czeka ich nowa przygoda!",
    "blockCategories": "Zakładki zeszytu",
    "actions": "Działania",
    "loops": "Pętle",
    "conditions": "Warunki",
    "title": "Run Marco! — Przygoda w twoim zeszycie",
    "home": "Strona główna Run Marco",
    "map": "Mapa przygody",
    "worlds": "Wybierz przygodę",
    "notebook": "Mój zeszyt",
    "notebookToggle": "Otwórz lub zamknij zeszyt",
    "notebookOpen": "Otwórz zeszyt",
    "notebookClose": "Obserwuj ścieżkę",
    "page": "Strona {number}",
    "level": "Trasa {number}",
    "run": "Ruszajmy!",
    "stop": "Zatrzymaj",
    "step": "Jeden krok",
    "stepTitle": "Wykonaj jedną instrukcję",
    "reset": "Wróć na start",
    "add": "Dodaj",
    "addLabel": "Wybierz klocek do dodania",
    "addHint": "Połącz klocki i naciśnij Graj.",
    "undo": "Cofnij",
    "clear": "Nowa strona",
    "hint": "Mała podpowiedź",
    "help": "Jak grać",
    "settings": "Ustawienia",
    "language": "Język gry",
    "blockLanguage": "Język klocków",
    "blockLanguageNote": "Możesz wybrać inny język dla klocków.",
    "musicOn": "Włącz dźwięk",
    "musicOff": "Wyłącz dźwięk",
    "sound": "Muzyka i efekty dźwiękowe",
    "speed": "Szybkość przygody",
    "chooseExplorer": "Wybierz odkrywcę",
    "explorer": "Odkrywca",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Zamknij",
    "done": "Odkrywajmy!",
    "loading": "Szukamy ścieżki…",
    "loadError": "Nie udało się wczytać przygody. Odśwież stronę, aby spróbować ponownie.",
    "imageError": "Nie udało się wczytać niektórych obrazków. Odśwież stronę.",
    "gemGoal": "Znajdź klejnot",
    "goal": "Znajdź złotą gwiazdkę",
    "cover": "Rozświetl każde pole dokładnie raz",
    "lit": "Rozświetlone pola: {count} / {total}",
    "explored": "Odkryte trasy: {count} / {total}",
    "facing": "Patrzy {direction} {arrow}",
    "boardLabel": "{name} na trasie {level}, patrzy {direction}. {steps}. {objective}.",
    "up": "w górę",
    "down": "w dół",
    "left": "w lewo",
    "right": "w prawo",
    "steps_one": "{count} krok",
    "steps_other": "{count} kroku",
    "blocks_one": "{count} klocek",
    "blocks_other": "{count} klocka",
    "stars_one": "{count} gwiazdka",
    "stars_other": "{count} gwiazdki",
    "place": "Dodaj klocki",
    "atEnd": "Na końcu",
    "insideRepeat": "W powtórzeniu {number}",
    "insideIf": "W jeżeli {number}",
    "insideElse": "W przeciwnym razie {number}",
    "readyFirst": "Mały krok. Dodaj klocek ruchu do przodu i ruszajmy!",
    "ready": "Dokąd idziemy? Ułóż plan w zeszycie.",
    "back": "Z powrotem na starcie. Klocki są gotowe na kolejną próbę.",
    "empty": "Najpierw dodaj klocek do zeszytu.",
    "win": "Droga znaleziona!",
    "winCover": "Cała ścieżka świeci!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Co za przygoda!",
    "simpler": "Czy dasz radę użyć mniej klocków?",
    "complete": "Trasa ukończona! Najlepsze gwiazdki zostały zapisane.",
    "next": "Następna trasa",
    "allWorlds": "Więcej przygód",
    "replay": "Zagraj ponownie",
    "shortGoal": "Prawie! Dodaj kilka klocków, aby dotrzeć do gwiazdki.",
    "shortGem": "Prawie! Dodaj kilka klocków, aby dotrzeć do klejnotu.",
    "shortCover": "Niektóre pola nadal są ciemne. Jak do nich dotrzemy?",
    "checking": "Obserwujemy ścieżkę…",
    "paused": "Zatrzymano. Graj zaczyna od początku.",
    "going": "W drogę!",
    "stepped": "O krok bliżej. Naciśnij Jeden krok lub Graj, aby kontynuować.",
    "clueCover": "Zacznij od krawędzi i przejdź cały kształt. Skok omija pole bez rozświetlania go.",
    "clueCondition": "Spójrz na ścieżkę przed sobą. Warunek pomaga odkrywcy wybrać działanie.",
    "clueRepeat": "Które kroki się powtarzają? Włóż ten wzór do klocka powtarzania.",
    "clueForward": "Do przodu to kierunek, w którym patrzy odkrywca. Policz pola do gwiazdki.",
    "clueGem": "Do przodu to kierunek, w którym patrzy odkrywca. Policz pola do klejnotu.",
    "clueTurn": "Obrót zmienia kierunek bez przesuwania. Prześledź ścieżkę palcem.",
    "mapNote": "Wybierz trasę. Najlepsze gwiazdki zostaną zachowane.",
    "mapLevel": "Trasa {number}: {name}. {stars}.",
    "locked": "Ukończ poprzednią trasę, aby odblokować tę.",
    "soundBlocked": "Dotknij przycisku dźwięku, aby usłyszeć przygodę.",
    "clearTitle": "Zacząć na nowej stronie?",
    "clearNote": "Klocki tej trasy zostaną usunięte. Cofnij może je przywrócić.",
    "keep": "Zachowaj moje klocki",
    "clearConfirm": "Usuń klocki",
    "fresh": "Nowa strona. Dokąd zaprowadzi nas twój następny plan?",
    "localProgress": "Twoje postępy są zapisywane na tym urządzeniu.",
    "helpBuild": "Ułóż plan",
    "helpBuildText": "Przeciągaj klocki do zeszytu i łącz je albo dotknij klocka, aby go dodać. Wybierz „W powtórzeniu”, aby dodać kroki do pętli.",
    "helpTurn": "Podążaj za odkrywcą",
    "helpTurnText": "Do przodu podąża za jego wzrokiem. Lewo i prawo obracają w miejscu. Skok pokonuje dwa pola.",
    "helpTry": "Próbuj, obserwuj i próbuj ponownie",
    "helpTryText": "Naciśnij Graj, aby sprawdzić plan, lub Jeden krok dla jednej instrukcji. Zakrzywiona strzałka wraca na start i zachowuje klocki.",
    "helpWorlds": "Każda przygoda ma cel",
    "helpWorldsText": "W Dżungli znajdź klejnot. W przygodzie świątecznej rozświetl każde wolne pole raz. W Świątyni i nad Morzem Egejskim wykonaj naprawy oraz widoczne cele i dotrzyj do wyjścia.",
    "noTrail": "Tam nie ma ścieżki! Spróbuj najpierw się obrócić.",
    "broken": "Ten most jest zepsuty. Czy możesz go przeskoczyć?",
    "blocked": "Coś blokuje drogę. Spróbuj skoku lub innej trasy.",
    "alreadyLit": "To pole już świeci. Odwiedź każde pole tylko raz.",
    "loopError": "Ten plan powtarza się bez końca. Spróbuj zmienić pętlę.",
    "repeatError": "Wybierz liczbę powtórzeń od 1 do 99.",
    "unsupported": "Usuń nieobsługiwany klocek i spróbuj ponownie.",
    "connect": "Połącz klocki w jeden łańcuch i naciśnij Graj.",
    "path": "ścieżka",
    "steps_few": "{count} kroki",
    "blocks_few": "{count} klocki",
    "stars_few": "{count} gwiazdki",
    "steps_many": "{count} kroków",
    "blocks_many": "{count} klocków",
    "stars_many": "{count} gwiazdek",
    "backpack": "Plecak",
    "templeGems": "Klejnoty świątyni",
    "gemsCollected": "Klejnoty: {count} / {total}",
    "gemsReady": "Wszystkie klejnoty zebrane!",
    "aegeanTitle": "Tajemnice Morza Egejskiego",
    "harbour": "Port",
    "aegeanDescription": "Odkrywaj port: naprawiaj stanowiska, używaj procedur wielokrotnie i przekazuj liczbę z każdym zleceniem.",
    "templeBetaNote": "Beta · Zagadki i lekcje są w trakcie zmian",
    "aegeanBetaNote": "Beta · Pierwsze 3 poziomy w porcie",
    "seasonal": "Przygoda sezonowa",
    "choosePreview": "Wybierz poziom pokazowy",
    "repairs": "Naprawy",
    "reachExit": "Dotrzyj do wyjścia",
    "taskRequirements": "Cele zadania",
    "lessonGuided": "Ćwiczenie z pomocą · uzupełnij gotowy program",
    "lessonRepair": "Szukanie błędów · popraw gotowy program",
    "lessonChallenge": "Wyzwanie · stwórz własny program",
    "acc_define_parameter": "Procedura",
    "acc_call_argument": "Wywołaj procedurę",
    "acc_repeat_parameter": "Powtórz z wejściem",
    "parameter": "parametr",
    "argument": "przekaż",
    "callInput": "Wejście tego wywołania",
    "inputWaiting": "Uruchom program lub wykonaj jedną instrukcję, aby zobaczyć następne wejście.",
    "argumentMismatch": "Procedura z parametrem wymaga wywołania z liczbą. Bez parametru użyj zwykłego wywołania.",
    "unsetParameter": "Używaj parametru tylko w procedurze, która go otrzymuje. Parametry są oddzielone od wspólnej pamięci.",
    "memoryObjective": "Sprawdź rejestr napraw i wymagania przy wyjściu. Każdy program, który je spełnia, jest akceptowany.",
    "gate": "Droga jest zablokowana. Sprawdź niedokończone naprawy.",
    "noPickup": "Stań na narzędziu, zanim je podniesiesz.",
    "creditLead": "Kierowanie zespołem i programowanie",
    "creditArt": "Ilustracje i scenografia",
    "creditAnimation": "Animacja",
    "creditUX": "Projekt interfejsu i doświadczenia użytkownika",
    "creditDesign": "Projekt gry",
    "creditStory": "Scenariusz",
    "creditAudio": "Muzyka i realizacja dźwięku",
    "lightLamp": "Zapal lampę",
    "oilLamp": "Lampa oliwna",
    "dustyStation": "zakurzone stanowisko",
    "betaLabel": "Beta",
    "noLamp": "Stań na zgaszonej lampie, zanim ją zapalisz.",
    "collected": "Narzędzie podniesione · gotowe do użycia",
    "dustyPrompt": "Stań na zakurzonym stanowisku przed użyciem pędzla.",
    "lampMissing": "Najpierw podnieś lampę oliwną. Zajrzyj do plecaka.",
    "recursiveRoutine": "Ta procedura wywołuje samą siebie. Użyj innej procedury; wywołania rekurencyjne nie są jeszcze dostępne."
  },
  "content": {
    "jungle.title": "Wyprawa do dżungli",
    "jungle.description": "Podążaj ścieżką do zaginionej świątyni.",
    "jungle-1": "Pierwsze kroki",
    "jungle-2": "Trochę dalej",
    "jungle-3": "Za rogiem",
    "jungle-4": "Zmień kierunek",
    "jungle-5": "Podążaj ścieżką",
    "jungle-6": "Nowa trasa",
    "jungle-7": "Nowe ścieżki",
    "jungle-8": "Skrzyżowanie w dżungli",
    "jungle-9": "Znajdź drogę",
    "jungle-10": "Myśl naprzód",
    "jungle-11": "Długa ścieżka",
    "jungle-12": "Kręta trasa",
    "jungle-13": "Odważny skok",
    "jungle-14": "Pojawiają się wzory",
    "jungle-15": "Powtórz rytm",
    "jungle-16": "Wybierz ścieżkę",
    "jungle-17": "Spójrz przed skokiem",
    "jungle-18": "Odczytaj ścieżkę",
    "jungle-19": "Sprytne obejście",
    "jungle-20": "Pod koronami drzew",
    "jungle-21": "Budowniczy mostów",
    "jungle-22": "Za rzeką",
    "jungle-23": "Odkryj ruiny",
    "jungle-24": "Kamień i drewno",
    "jungle-25": "Większy skok",
    "jungle-26": "Podążaj za wskazówkami",
    "jungle-27": "Wyżej",
    "jungle-28": "Odkrywaj dalej",
    "jungle-29": "Kręte ścieżki",
    "jungle-30": "Tajemniczy ogród",
    "jungle-31": "Ukryte wzory",
    "jungle-32": "Pradawne ścieżki",
    "jungle-33": "Ostatnie zakręty",
    "jungle-34": "W stronę świątyni",
    "jungle-35": "Już prawie",
    "jungle-36": "Zaginiona świątynia",
    "winter.title": "Zimowa ścieżka",
    "winter.description": "Rozświetl każdy ślad stopy.",
    "winter-1": "Kroki na śniegu",
    "winter-2": "Inny kierunek",
    "winter-3": "Zamarznięte zakątki",
    "winter-4": "Długa droga naokoło",
    "winter-5": "Płatek śniegu",
    "winter-6": "Zimowe pętle",
    "winter-7": "Odkrywca lodu",
    "winter-8": "Skręty i zakręty",
    "winter-9": "Lodowata logika",
    "winter-10": "Poszukiwacz wzorów",
    "winter-11": "Mistrz ścieżki",
    "winter-12": "Zimowy cud",
    "temple.title": "Zaginiona świątynia",
    "temple.description": "Czterdzieści połączonych komnat. Napraw niebiański przyrząd za pomocą narzędzi, pamięci i własnych procedur."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Kosz jest pusty",
    "OPEN_TRASH": "Otwórz kosz",
    "BLOCK_LABEL_BEGIN_STACK": "Początek łańcucha",
    "WORKSPACE_LABEL_1_STACK": "1 łańcuch klocków",
    "WORKSPACE_LABEL_MANY_STACKS": "Łańcuchy klocków: %1",
    "ARIA_TYPE_FIELD_NUMBER": "liczba",
    "ARIA_TYPE_FIELD_DROPDOWN": "lista rozwijana",
    "ARIA_TYPE_FIELD_IMAGE": "obraz",
    "WORKSPACE_LABEL_PLAIN": "Mój zeszyt",
    "FIELD_LABEL_EDIT_PREFIX": "Edytuj %1",
    "BLOCK_LABEL_HAS_INPUT": "ma wejście",
    "BLOCK_LABEL_HAS_INPUTS": "ma wejścia",
    "BLOCK_LABEL_HAS_BRANCHES": "gałęzie: %1",
    "FIELD_LABEL_OPTION_INDEX": "Opcja %1",
    "INPUT_LABEL_EMPTY": "Puste",
    "BLOCK_LABEL_DISABLED": "wyłączone",
    "BLOCK_LABEL_COLLAPSED": "zwinięte",
    "BLOCK_LABEL_BEGIN_PREFIX": "Początek: %1",
    "INPUT_LABEL_END_STATEMENT": "Koniec: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "tekst",
    "ARIA_TYPE_FIELD_INPUT": "dane wejściowe",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "nazwa wejścia",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "nazwa procedury"
  }
}
